export function formatHours(hours) {
    return `${Math.round(hours || 0).toLocaleString()}h`
}
